import { render, staticRenderFns } from "./BillingIcon.vue?vue&type=template&id=d2513c30&"
import script from "./BillingIcon.vue?vue&type=script&lang=js&"
export * from "./BillingIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports